const Widgets = () => {
  return <h1>Widgets</h1>;
};
export default Widgets;
